module.exports = __webpack_public_path__ + "img/Slide3.jpg";